import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import dropdown from "./src/dropdown.vue";
import dropdownItem from "./src/dropdown-item.vue";
import dropdownOp from "./src/dropdown-op.vue";
export const xDropdown = withInstall(dropdown, { dropdownItem, dropdownOp });
export default xDropdown;
export const xDropdownItem = withNoopInstall(dropdownItem);
export const xDropdownOp = withNoopInstall(dropdownOp);
export * from "./src/dropdown";
